$(document).ready(function () {
    // --- Globals --- //
    // Search will hide/show relevant submissions
    $('input#searchterm').keyup(function () {
        var value = $(this).val();
        var regex = new RegExp(value, 'i');

        $('table tr').not('table tr:first-child').each(function () {
            if (regex.test($(this).children('td').text())) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });
});
